import { element } from 'protractor';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import * as _ from 'lodash';
import { CUSTOMERS_BY_CUSTOMER_ENDPOINT } from 'src/app/core/config/config.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { DataService } from 'src/app/core/services/data.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { FilterService } from '../filter/filter.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/appState.interface';
import { getCustomersSelector } from 'src/app/core/store/selectors';


@Component({
  selector: 'app-cutomers-tree',
  templateUrl: './cutomers-tree.component.html',
  styleUrls: ['./cutomers-tree.component.scss']
})
export class CutomersTreeComponent implements OnInit, OnChanges {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView: DxTreeViewComponent;
  public customers: any;
  @Output() customerSelected = new EventEmitter<any>();
  @Input() refreshCustomers: boolean;

  treeElementsList: any[] = [];

  @Input() isForFilter: boolean = false;

  @Input() isVehicleChangeCustomer: boolean = false;

  mainColorClass: string;
  isLoading: boolean

  constructor(
    private apiService: ApiService,
    public dialog: MatDialog,
    private utilsService: UtilsService,
    private filterService: FilterService,
    private dataService: DataService,
    private spinner: NgxSpinnerService,
    private store: Store<AppStateInterface>) {
      this.mainColorClass = this.utilsService.getStylesheetString() + '-main-bgcolor';
     }

  ngOnInit(): void {
    this.getCustomers();

    this.filterService.applyFilterEvent.subscribe(
      (data: any) => {
        this.filterService.updateSelectedCustomerCache();
      }
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.refreshCustomers){
      this.refreshCustomersFromAPI();
    }
  }

  getCustomers() {
    this.spinner.show();
    this.isLoading = true;
    let userInfo = this.dataService.getCurrentUserInfo();

    this.store.select(getCustomersSelector).subscribe(
      (customers: any) => {
        if (!customers || customers.length === 0) {
          this.spinner.hide();
          this.isLoading = false;
          return;
        }

        // Create a mutable deep copy of the customers array
        this.customers = _.cloneDeep(customers);
        this.updateCustomerListWithChildrenInfo(this.customers);

        setTimeout(() => {
          if (this.treeView && this.treeView.instance) {
            const uidToExpand = this.isForFilter
              ? this.filterService.getSelectedCustomer()?.uid || userInfo?.customer?.uid
              : userInfo?.customer?.uid;

            if (uidToExpand) {
              try {
                this.treeView.instance.expandItem(uidToExpand);
              } catch (error) {
                console.warn('Failed to expand tree item:', error);
              }
            }
          }
        }, 100);

        this.spinner.hide();
        this.isLoading = false;
      }
    );
  }

  refreshCustomersFromAPI() {
    this.spinner.show();
    this.isLoading = true;
    let userInfo = this.dataService.getCurrentUserInfo();
    this.apiService.get(CUSTOMERS_BY_CUSTOMER_ENDPOINT + '/' + userInfo.customer.uid)
      .subscribe(
        (customers: any) => {
          this.customers = customers;
          this.updateCustomerListWithChildrenInfo(customers);
          setTimeout(() => {
            if (this.treeView && this.treeView.instance) {
              const uidToExpand = this.isForFilter
                ? this.filterService.getSelectedCustomer()?.uid || userInfo?.customer?.uid
                : userInfo?.customer?.uid;

              if (uidToExpand) {
                try {
                  this.treeView.instance.expandItem(uidToExpand);
                } catch (error) {
                  console.warn('Failed to expand tree item:', error);
                }
              }
            }
          }, 100);
          this.spinner.hide();
          this.isLoading = false;
        },
        error => {
          this.spinner.hide();
          this.isLoading = false;
          this.utilsService.showErrorPopup(error);
        });
  }

  onItemClick(e: any) {
    this.isForFilter = true;
    this.customerSelected.emit(e.itemData);
    if (this.isForFilter && !this.isVehicleChangeCustomer) {
      this.filterService.setSelectedCustomer(e.itemData);
      this.filterService.handleCustomerClick(this.treeView);
    }
    let treeview = <HTMLCollectionOf<HTMLElement>>document.getElementsByClassName("dx-treeview-item");
    for (let index = 0; index < treeview.length; index++) {
      treeview.item(index)?.classList.remove(this.mainColorClass);
    }
    (e.itemElement as HTMLElement).classList.add(this.mainColorClass);
  }

  onItemCollapseAndExpanded(e: any) {
    if (this.isForFilter)
      this.filterService.handleTreeExpansionAndCollision(this.treeView);
  }

  onContentReady(e: any) {
    var selectElement = document.querySelectorAll('.dx-icon');
    for (var i = 0; i < selectElement.length; i++) {
      selectElement[i].addEventListener('click', () => {
        this.isForFilter = false;
        setTimeout(() => {
          this.treeView.instance.collapseAll();
          this.treeView.instance.expandItem(this.isForFilter ? this.filterService.getSelectedCustomer() ? this.filterService.getSelectedCustomer().uid : this.dataService.getCurrentUserInfo().customer.uid : this.dataService.getCurrentUserInfo().customer.uid);
        });
      });
    }
    e.element.classList.add(this.utilsService.getStylesheetString());
    if (this.isForFilter) this.filterService.setCustomerTreeItems(this.treeElementsList);
  }

  onItemRendered(e: any) {
    if (this.isForFilter) this.treeElementsList.push(e);
    var span = e.itemElement.getElementsByTagName("span")[0];
    if (e.itemData.isHardLocked === true) {
      span.classList.add('aft-disabled__color');
    }
    else {
        span.classList.remove('aft-disabled__color');
    }
  }

  updateCustomerListWithChildrenInfo(customerList) {
    let self = this
    _.each(self.customers, function (customer) {
      var childrens;

      // Not root
      if (customer.uidParent !== null) {
        var customerParent = _.find(customerList, { uid: customer.uidParent });
        if (customerParent) {
          childrens = _.filter(customerList, { uidParent: customer.uidParent });
          customerParent.nameWithChildren = customerParent.name + ' (' + childrens.length + ')';
        }
      } else {
        // Root customer
        childrens = _.filter(customerList, { uidParent: customer.uid });
        customer.nameWithChildren = customer.name + ' (' + childrens.length + ')';
      }
      if (!customer.nameWithChildren) customer.nameWithChildren = customer.name;
    });
  }
}
